import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { map, Observable, startWith } from "rxjs";
import { STATES_OF_BRAZIL } from "src/app/shared/data/state";
import { AddressDto } from "src/app/shared/models/address.dto";
import { BusinessUnitDto } from "src/app/shared/models/business-unit.dto";
import { CustomerAllegationDto } from "src/app/shared/models/customer-allegation.dto";
import { CustomerDto } from "src/app/shared/models/customer.dto";
import { FrequentUseDto } from "src/app/shared/models/frequent-use.dto";
import { PhotoData } from "src/app/shared/models/photo-data.dto";
import { PWProductDto } from "src/app/shared/models/pw-product.dto";
import { PwSacDto } from "src/app/shared/models/pw-sac.dto";
import { RoadDto } from "src/app/shared/models/road.dto";
import { VehicleBrandDto } from "src/app/shared/models/vehicle-brand.dto";
import { BusinessUnitService } from "src/app/shared/services/business-unit/business-unit.service";
import { CustomerAllegationService } from "src/app/shared/services/customer-allegation/customer-allegation.service";
import { FrequentUseService } from "src/app/shared/services/frequent-use/frequent-use.service";
import { RoadService } from "src/app/shared/services/road/road.service";
import { VehicleBrandService } from "src/app/shared/services/vehicle-brand/vehicle-brand.service";
import { ZipService } from "src/app/shared/services/viaCep.service";

export abstract class PwSacBaseComponent {

    pwForm!: FormGroup;
    handleZipCode = false;
    isLoadingZipCode = false;
    isLoadingBrands = false;
    pwSpecialValue: string = 'Y'
    states = STATES_OF_BRAZIL;
    businessUnitList: BusinessUnitDto[] = [];
    roadList: RoadDto[] = [];
    frequentUseList: FrequentUseDto[] = [];
    customerAllegationList: CustomerAllegationDto[] = [];
    showTireSection: boolean = false;
    showTerm: boolean = false;

    vehicleBrandList: VehicleBrandDto[] = [];
    filteredBrands!: Observable<VehicleBrandDto[]>;
    brandCtrl = new FormControl();

    imagesFormArray: any;

    constructor(
        protected businessUnitService: BusinessUnitService,
        protected roadService: RoadService,
        protected frequentUse: FrequentUseService,
        protected zipService: ZipService,
        protected customerAllegationService: CustomerAllegationService,
        protected vehicleBrandService: VehicleBrandService
    ) { }

    loadBusinessUnit() {
        this.businessUnitService.getAll().subscribe({
            next: (data) => {
                this.businessUnitList = data;
            },
            error: (err) => {
                console.log('Erro ao carregar a lista de tipo de veículo.', err)
            }
        });
    }

    loadRoadList() {
        this.roadService.getAll().subscribe({
            next: (data) => {
                this.roadList = data;
            },
            error: (err) => {
                console.log('Erro ao carregar a lista de tipo de estrada.', err)
            }
        });
    }

    loadFrequentUseList() {
        this.frequentUse.getAll().subscribe({
            next: (data) => {
                this.frequentUseList = data;
            },
            error: (err) => {
                console.log('Erro ao carregar a lista de Uso Frequente.', err)
            }
        });
    }

    loadCustomerAllegation() {
        this.showTireSection = true
        const formValues = this.pwForm.getRawValue();
        const businessUnit: BusinessUnitDto = formValues.vehicle.businessUnit;
        this.customerAllegationService.getByBusinessUnit(businessUnit.id).subscribe({
            next: (data) => {
                this.customerAllegationList = data;
            },
            error: (err) => {
                console.log('Erro ao carregar a lista de alegação do cliente.', err)
            }
        });
    }

    loadVehicleBrand() {
        const formValues = this.pwForm.getRawValue();
        const businessUnit: BusinessUnitDto = formValues.vehicle.businessUnit;
        const formVehicle = this.pwForm.get('vehicle');
        formVehicle?.get('brand')?.setValue("")
        this.isLoadingBrands = true;
        this.vehicleBrandService.getByBusinessUnit(businessUnit.id).subscribe({
            next: (data) => {
                this.isLoadingBrands = false;
                this.vehicleBrandList = data;
                this.filteredBrands = this.brandCtrl?.valueChanges.pipe(
                    startWith(''),
                    map(value => this._filterBrands(value || ''))
                );
            },
            error: (err) => {
                this.isLoadingBrands = false;
                console.log('Erro ao carregar a lista de marcas de veículo.', err)
            }
        });
    }

    onZipCodeChange() {
        const zip = this.pwForm.get('address.zipcode')?.value;

        if (!zip || zip.replace(/\D/g, '').length !== 8) return;
        this.handleZipCode = true;
        this.isLoadingZipCode = true;
        const cleanZip = zip.replace(/\D/g, '');

        this.zipService.getZipData(cleanZip).subscribe({
            next: (data) => {
                this.isLoadingZipCode = false;
                if (!data.erro) {
                    const addressGroup = this.pwForm.get('address');
                    addressGroup?.get('state')?.setValue(data.uf);
                    addressGroup?.get('city')?.setValue(data.localidade);
                    addressGroup?.get('neighborhood')?.setValue(data.bairro);
                    addressGroup?.get('street')?.setValue(data.logradouro);
                    addressGroup?.get('state')?.disable();
                    addressGroup?.get('city')?.disable();
                    addressGroup?.get('neighborhood')?.disable();
                    addressGroup?.get('street')?.disable();
                } else {
                    const addressGroup = this.pwForm.get('address');
                    addressGroup?.get('state')?.setValue("RJ");
                    addressGroup?.get('city')?.setValue("");
                    addressGroup?.get('neighborhood')?.setValue("");
                    addressGroup?.get('street')?.setValue("");
                    addressGroup?.get('state')?.enable();
                    addressGroup?.get('city')?.enable();
                    addressGroup?.get('neighborhood')?.enable();
                    addressGroup?.get('street')?.enable();
                }

            },
            error: (err) => {
                this.isLoadingZipCode = false;
                console.error('Erro na busca do CEP:', err);
            }
        });
    }

    getImagesFormArray(index: number): FormArray | null {
        const tireFormGroup = (this.pwForm.get('tires') as FormArray).at(index) as FormGroup | null;
        if (!tireFormGroup) {
            console.error(`FormGroup não encontrado para o índice ${index}`);
            return null;
        }
        const imagesFormArray = tireFormGroup.get('images') as FormArray | null;            
        if (!imagesFormArray) {
            console.error(`FormArray de images não encontrado para o índice ${index}`);
            return null;
        }
        return imagesFormArray;
    }

    getProducts(loadFile: Boolean = true): PWProductDto[] {
        const productList: PWProductDto[] = [];
        const tiresFormArray = this.pwForm.get('tires') as FormArray;
        tiresFormArray.controls.forEach((tireControl, productIndex) => {
            const imagesArray = this.getImagesFormArray(productIndex);
            (imagesArray.value as PhotoData[]).forEach((img, index) => {
                const pWProductDto: PWProductDto = new PWProductDto();
                pWProductDto.productOrder = productIndex + 1;
                pWProductDto.description = img.name;
                pWProductDto.additionalInformation = tireControl?.value?.additionalInformation;
                pWProductDto.customerAllegationId =  tireControl?.value?.customerAllegation?.externalId; 
                if (loadFile)
                    pWProductDto.image = img.url;
                productList.push(pWProductDto);
            });
        });
            
        return productList;
    }


    buildDtoFromForm(): PwSacDto {
        const formValues = this.pwForm.getRawValue();
        const address = new AddressDto();
        address.zipcode = formValues.address.zipcode;
        address.state = formValues.address.state;
        address.city = formValues.address.city;
        address.neighborhood = formValues.address.neighborhood;
        address.address = formValues.address.street;
        address.number = formValues.address.number;
        address.complement = formValues.address.complement;

        const customer = new CustomerDto();
        customer.name = formValues.customer.name;
        customer.document = formValues.customer.document;
        customer.email = formValues.customer.email;
        customer.phone = formValues.customer.phone;
        customer.address = address;

        const pwSacDto = new PwSacDto();
        pwSacDto.customer = customer;
        pwSacDto.businessUnit = (formValues.vehicle.businessUnit).id;
        pwSacDto.roadId = (formValues.vehicle.road).id;
        pwSacDto.brandId = (formValues.vehicle.brand).id;
        pwSacDto.model = formValues.vehicle.model;
        pwSacDto.year = formValues.vehicle.year;
        pwSacDto.km = formValues.vehicle.km;
        pwSacDto.frequentUseId = (formValues.vehicle.frequentUse).id;
        pwSacDto.productQty = formValues.productQuantity;
        pwSacDto.type = formValues.allegation.pwSpecial === this.pwSpecialValue ? 'SPECIAL' : 'NORMAL';
        pwSacDto.customerAllegation = formValues.allegation.description;       
        pwSacDto.additionalInformation = '';
        pwSacDto.products = this.getProducts(false);

        return pwSacDto;
    }

    private _filterBrands(value: string): VehicleBrandDto[] {
        const filterValue = value.toLowerCase();
        return this.vehicleBrandList.filter(brand => brand.name.toLowerCase().includes(filterValue));
    }

}